module.exports = __webpack_public_path__ + "img/Plan2012.c3063e14.jpg";